import { render, staticRenderFns } from "./formulario_campo_builder.vue?vue&type=template&id=ae2eddac&scoped=true&"
import script from "./formulario_campo_builder.vue?vue&type=script&lang=js&"
export * from "./formulario_campo_builder.vue?vue&type=script&lang=js&"
import style0 from "./formulario_campo_builder.vue?vue&type=style&index=0&id=ae2eddac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2eddac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VProgressCircular,VRadio,VRadioGroup,VSelect,VSwitch,VTextField,VTextarea})
